import { useEffect, useState } from "react"
import { axios } from "../../helpers"
import useYoutube from "../../hooks/useYoutube"
import GLightbox from "glightbox"

const useGalleryVideo = () => {
    const [dataVideo, setDataVideo] = useState([])
    const [isLoadingVideo, setIsLoadingVideo] = useState(false)
    const [page, setPage] = useState(1)
    const [totalPage, setTotalPage] = useState(0)
    const { getThumbnailImage } = useYoutube()
    useEffect(() => {
        const lightbox = GLightbox({ selector: '.glightbox' });
        return () => {
            lightbox.destroy();
        };
    }, [dataVideo])

    useEffect(() => {
        fetchVideo();
    }, [])

    const fetchVideo = async () => {
        setIsLoadingVideo(true)
        try {
            const response = await axios.get(`/galeri?kategori=3&page=${page}`)
            if (response.status === 200) {
                setDataVideo(response.data.data.rows)
                setTotalPage(response.data.data.total_pages)
            }
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoadingVideo(false)
        }
    }

    return {
        page,
        totalPage,
        dataVideo,
        isLoadingVideo,
        setPage,
        getThumbnailImage
    }
}
export default useGalleryVideo